export const handleChangeDataModalVideo = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_VIDEO', name, value
});